// Module
var code = "<ui-view> <financial-accounts-list></financial-accounts-list> </ui-view> ";
// Exports
module.exports = code;